import { render } from "./ConsomablesComp.vue?vue&type=template&id=8df381aa&scoped=true"
import script from "./ConsomablesComp.vue?vue&type=script&lang=js"
export * from "./ConsomablesComp.vue?vue&type=script&lang=js"

import "./ConsomablesComp.vue?vue&type=style&index=0&id=8df381aa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8df381aa"]])

export default __exports__